import { bl_sfa_project_hdr_RowClass } from "../../../dbschema/bl_sfa_project_hdr.model";
import { BaseContainerModel } from "../../base-container.model";

export class SfaProjectHdrContainerModel extends BaseContainerModel {
    bl_sfa_project_hdr: bl_sfa_project_hdr_RowClass = new bl_sfa_project_hdr_RowClass();
}